import React from 'react';
import './FuelEUMonitoringForm.scss';
import { useNavigate } from 'react-router-dom';


const FuelEUMonitoringHeader = () => {

  const navigate = useNavigate()

  const redirectToForm = () => {
    navigate('/fuel-monitoring-plan/form')

  }


  return (
    <div className='fuel-monitoring-header-container'>
      <nav aria-label="breadcrumb">
        <ul className="breadcrumb">
          <li className="breadcrumb-item">
            <a>Fuel EU Monitoring Plan</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            List of Form Submissions
          </li>
        </ul>
      </nav>
      <div className="heading-button-container">
        <h1 className="page-heading">List of Form Submissions</h1>
        <button className="action-button" onClick={redirectToForm}>NEW SUBMISSION</button>
      </div>
    </div>
  )
}

export default FuelEUMonitoringHeader